export const ITEM_PAGE_PREFIX = 'Item_page'
